<div class="tml-tpl-input checkbox" *ngIf="childConfig">
    <div *ngIf="isShowChecked" class="config-option">
        <div class="tam-form-label label-area">
            <div class="field-name body-2 text-ellipsis">
                {{'general.required' | stringLiterals}}
            </div>
        </div>
        <kendo-switch class="kendo-switch-medium-with-label" [(ngModel)]="isCheck"
            onLabel="{{'general.yes' | stringLiterals}}" offLabel="{{'general.no' | stringLiterals}}"
            [disabled]="childConfig.config.controlID ==='FirstName'" (valueChange)="oncheckedChange($event)">
        </kendo-switch>
        <div>
            <label *ngIf="showAddressTip" class="option-tip">{{'general.config-address-tipn' | stringLiterals}}</label>
        </div>
        <div>
            <label *ngIf="showEmailTip" class="option-tip">{{'general.config-email-tip' | stringLiterals}}</label>
        </div>
    </div>
    <div *ngIf="isShowJobTitleFly" class="config-option">
        <label>{{'general.options' | stringLiterals}}</label>
        <div class="dropdown-options">
            <label *ngIf="isShowJobTitleFly" tam-checkbox [(ngModel)]="isFlyCheck" (click)="oncheckedFlyChange($event)"
                [disabled]="!isPPCUser"></label><span class="allow-fly-tip">{{'general.allow_fly_option' |
                stringLiterals}}</span>
        </div>
    </div>
    <div class="columnSize config-option" *ngIf="false">
        <label>{{'general.column_size' | stringLiterals}}</label>
        <div *ngFor="let item of columnSize;let i = index;">
            <button tam-button tamType="tertiary" tamSize="normal" class="template-columnSize-button"
                (click)="clickColumnSize($event,item,i)" [ngClass]="{ 'div-border-selected':selectedIndex===i}"
                [disabled]="birthdayButtonDisabled">{{item}}</button>
        </div>
    </div>
    <div *ngIf="isShowOptions" class="config-option">
        <label>{{'general.dropdown_option' | stringLiterals}}</label>
        <div class="dropdown-options">
            <textarea class="tam-textbox field-control text-area-height" type="text" [(ngModel)]="defaultOptionsSource"
                (keyup)="enterValue($event)" placeholder="{{sourcePlaceHolder}}"></textarea>
        </div>
    </div>
    <div *ngIf="showAddressTip" class="config-option">
        <label>{{'general.set_default_country' | stringLiterals}}</label>
        <div class="country-dropdown">
            <kendo-dropdownlist [(ngModel)]="valueCountry" [data]="valueCountryList" style="width:100%"
                (valueChange)="changeValueCountry($event)">
            </kendo-dropdownlist>
        </div>
    </div>
</div>
<div *ngIf="showCompanyDropdown" class="config-option">
    <label>{{'general.company_field_options' | stringLiterals}}</label>
    <div class="dropdown-options">
        <div>{{'general.company_filter_entity_type' | stringLiterals}}</div>
        <div>{{'general.entity-type' | stringLiterals}}</div>
        <multi-sel-dropdown-filter [dropdownConfig]="dropdownConfig">
        </multi-sel-dropdown-filter>
    </div>
</div>

<div *ngIf="showSection">
    <div class="config-option">
        <label>{{'general.section_name' | stringLiterals}}</label>
        <input class="tam-input" [(ngModel)]="sectionName" style="width:100%" (keyup.enter)="enterValue($event)"
            disabled />
    </div>
</div>